import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { loginRequest } from "./authConfig";
import ProviderWrapper from "./Components/Contexts/ProviderWrapper";
import MainPage from "./MainPage";

function App() {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    const activeAccount = instance.getActiveAccount();
    if (!activeAccount && accounts.length === 0) {
      instance.loginRedirect(loginRequest).catch((e) => {});
    }
  }, [instance, accounts]);

  return (
    <div className="App">
      <AuthenticatedTemplate>
        <BrowserRouter>
          <ProviderWrapper>
            <Routes>
              <Route path="/home" element={<MainPage />} />
              <Route path="/" element={<Navigate to="/home" />} />
            </Routes>
          </ProviderWrapper>
        </BrowserRouter>
      </AuthenticatedTemplate>
    </div>
  );
}

export default App;
